import { documentListConstants } from '../../constants/document-list.constants';

const ps = JSON.parse(localStorage.getItem('dspxDocumentsPageSize'));

const defaultState = {
	dataFetching: false,
	recordsRequest: undefined,
	attachmentsRequest: undefined,
	selectedDocuments: [],
	pageSize: ps ? ps : 10,
}

export default (state = defaultState, action = {}) => {
	switch (action.type) {
		case documentListConstants.SET_SELECTED_ROWS: {            
			return {
				...state,
				selectedDocuments: action.payload,
			}
		}
		case documentListConstants.SET_RECORDS_REQUEST: {
			return {
				...state,
				recordsRequest: action.payload,
			}
		}
		case documentListConstants.SET_ATTACHMENTS_REQUEST: {
			return {
				...state,
				attachmentsRequest: action.payload,
			}
		}
		case documentListConstants.SET_PAGE_SIZE: {            
			return {
				...state,
				pageSize: action.payload,
			}
		}

		default:
			return state;
	}
}